import * as React from 'react';

import * as style from './style.css';

export interface IActionButtonsProps {
  call: React.ReactElement;
  newReview: React.ReactElement;
}

export const ActionButtons: React.FC<IActionButtonsProps> = ({ call, newReview }) => {
  return (
    <div data-testid="ReviewsButtons" className={style['buttons']}>
      <div className={style['button']}>{call}</div>

      <div className={style['button']}>{newReview}</div>
    </div>
  );
};
